export default () => (
  <path d="M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20Zm-1.563-6.875h.938v-2.5h-.938a.935.935 0 0 1-.937-.938c0-.519.418-.937.938-.937h1.874c.52 0 .938.418.938.938v3.437h.313c.519 0 .937.418.937.938a.935.935 0 0 1-.938.937h-3.124a.935.935 0 0 1-.938-.938c0-.519.418-.937.938-.937ZM12 7a1.25 1.25 0 1 1 0 2.5A1.25 1.25 0 0 1 12 7Z" />
);
